import { Controller } from "@hotwired/stimulus"

export default class SessionTokenController extends Controller {
  static targets = ["sessionTokenInput"]

  connect() {
    this.rotate()
  }

  rotate() {
    const token = crypto.randomUUID()

    this.sessionTokenInputTargets.forEach((input) => {
      input.value = token
    })
  }

  get token() {
    return this.hasSessionTokenInputTarget
      ? this.sessionTokenInputTarget.value
      : null
  }
}
